module.exports = __webpack_public_path__ + "static/media/Resolved.aaa2fa2b.svg";